import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
// mantine
import { Button, Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// icons
import { Plus } from 'lucide-react';
// components
import Header from '@/components/Layout/components/Header';
import PersonSelect from '@/pages/AKB/components/PersonaSelect';
import TopicForm from '@/pages/AKB/components/TopicForm';
// utils
import useAKBStore from '@/pages/AKB/AKB.store.ts';
import { usePersonaQuery } from '@/services/bff/bff.queries.ts';

const AKBHeader = () => {
    const { personaId = '' } = useParams();
    // Add Topic modal
    const [isModalOpened, handlers] = useDisclosure(false);
    const setPersona = useAKBStore((state) => state.setPersona);
    const storedPersona = useAKBStore((state) => state.persona);
    const { data: persona } = usePersonaQuery(personaId);
    useEffect(() => {
        if (persona) {
            setPersona(persona);
        }
    }, [persona, setPersona]);

    const handleModalOpen = () => {
        handlers.open();
    };

    const handleModalClose = () => {
        handlers.close();
    };

    return (
        <>
            <Header
                breadcrumbs={[{ label: 'AKB' }]}
                className="justify-between"
            >
                <PersonSelect />
                <Button
                    disabled={!storedPersona?.id}
                    leftSection={<Plus />}
                    size="xs"
                    variant="filled"
                    onClick={handleModalOpen}
                >
                    Add New Topic
                </Button>
            </Header>
            {storedPersona ? (
                <Modal
                    opened={isModalOpened}
                    size="70%"
                    title="Add New Topic"
                    onClose={handleModalClose}
                >
                    <TopicForm
                        personaId={storedPersona.id}
                        onClose={handleModalClose}
                    />
                </Modal>
            ) : undefined}
        </>
    );
};

export default AKBHeader;
